import * as React from 'react';
import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'flex min-h-24 w-full rounded-vt-sm border border-vt-border bg-vt-surface px-3 py-2 text-vt-14 leading-relaxed text-vt-text shadow-vt-1 transition-[border-color,box-shadow] duration-vt ease-vt placeholder:text-vt-text-soft hover:border-vt-border-strong focus-visible:border-vt-primary-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vt-primary-400/30 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-vt-alert aria-[invalid=true]:ring-vt-alert/20',
      className
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
